export default __webpack_public_path__ + "static/media/line-img.6ce86822.svg";